// src/pages/DashboardHome.jsx (CORRECTED)

import React from 'react';
// OLD: import DashboardLayout from '../../layouts/DashboardLayout'; 
// NEW: Corrected path is one level up to 'src/pages/', then down into 'layouts/'
import DashboardLayout from '../layouts/DashboardLayout'; 

const DashboardHome = () => {
    
    // Placeholder function for a text icon (using a simple circle)
    const ListItemIcon = ({ color = 'var(--color-sky)' }) => (
        <span style={{ color: color, marginRight: '10px', fontWeight: 'bold' }}>•</span>
    );

    return (
        <DashboardLayout>
            <div className="dashboard-home">
                <h1 className="dashboard-page-title">Welcome Back, [User Name]!</h1>
                {/* ... rest of the component code ... */}
            </div>
        </DashboardLayout>
    );
};

export default DashboardHome;